import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const SectionContainer = styled.section`
  width: 100%;
`;

export const MainViewContainer = styled.section`
  width: 100%;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  border-radius: 4px;
  margin-top: 30px;
  margin-left: 0px;
`;

export const FlexSection = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const OuterSection = styled.section`
  width: 95%;
  border-radius: 5px;
  overflow: visible;
  opacity: ${(props) => (props.$isLoading ? 0.5 : 1)};
  pointer-events: ${(props) => (props.$isLoading ? "none" : "auto")};
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  background: ${(props) => props.background ?? "#fff"};
  gap: ${(props) => props.gap ?? "1.25rem"};
  padding: ${(props) => props.padding ?? "12px 16px"};
  box-shadow: ${(props) => props.boxShadow ?? "0 0px 0 0 #e5e5e5"};
  border-radius: ${(props) => props.borderRadius ?? "0px 0 0 0px"};
  margin: ${(props) => props.margin ?? "0px"};
  border: ${(props) => props.border ?? "none"};
  border-bottom: ${(props) => props.borderBottom ?? "none"};
  border-top: ${(props) => props.borderTop ?? "none"};
  overflow: ${(props) => props.overflow ?? "visible"};
  align-items: ${(props) => props.alignItems ?? "initial"};
`;

export const Title = styled.h2`
  width: 100%;
  text-align: left;
  font-family: "Lato";
  font-size: 22px;
  line-height: 22px;
  margin: 0;
  color: #ff5200;
  text-transform: capitalize;
  font-weight: bold;
  align-content: center;
`;

export const MoreDropdownMenu = styled.div`
  position: absolute;
  right: 0;
  z-index: 9999999999999999;
  display: ${(props) => props.display ?? "none"};
  float: right;
  min-width: 70px;
  padding: 5px 0;
  margin: 2px 0 0;
  font-size: 14px;
  text-align: left;
  list-style: none;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
`;

export const GridCell = styled.div`
  font-family: Lato;
  font-size: ${(props) => props.fontSize ?? "14px"};
  font-style: ${(props) => props.fontStyle ?? "normal"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  color: ${(props) => props.color ?? "#fff"};
  display: ${(props) => props.display ?? "block"};
  align-items: ${(props) => props.alignItems ?? "initial"};
  text-align: ${(props) => props.textAlign ?? "initial"};
  justify-content: ${(props) => props.justifyContent ?? "initial"};
`;

export const GridCellTitle = styled.span`
  color: #004c7f;
  font-size: ${(props) => props.fontSize ?? "14px"};
  font-weight: 700;
  white-space: break-spaces;
`;

export const GridCellValue = styled.span`
  color: ${(props) => props.color ?? "#767676"};
  font-size: ${(props) => props.fontSize ?? "14px"};
  font-weight: 400;
  white-space: break-spaces;
`;

export const GridCellPara = styled.p`
  color: #474747;
  font-size: 13px;
  font-weight: 400;
  white-space: break-spaces;
  font-style: italic;
`;

export const RecipientCard = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid ${(props) => (props.$isSelected ? "#32a728" : "#e5e5e5")};
  background: ${(props) => (props.$isSelected ? "#ebf6ea" : "#fff")};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const RecipientInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RecipientName = styled.span`
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  color: #474747;
`;

export const RecipientEmail = styled.span`
  font-family: Lato;
  font-size: 14px;
  color: #15aee5;
`;

export const RecipientNoEmail = styled.span`
  font-family: Lato;
  font-size: 14px;
  font-style: italic;
  color: #767676;
`;

export const ErrorMessagePara = styled.p`
  font-size: 1rem;
  font-family: Lato;
  line-height: 1;
  text-transform: initial;
  font-weight: bold;
  color: red;
  margin: 0;
  padding: 0;
  position: relative;
  white-space: nowrap;
`;

export const QuantityLineOuter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 153px;
`;

export const ContainerLabel = styled.label`
  display: block;
  width: auto;
  font-family: Lato;
  font-style: ${(props) => props.fontStyle ?? "normal"};
  font-weight: 700;
  font-size: ${(props) => props.fontSize ?? "0.9375rem;"};
  line-height: 1;
  color: ${(props) => props.color ?? " #1bace4"};
  margin-bottom: 6px;
  cursor: ${(props) => props.cursor ?? "default"};
  text-decoration: ${(props) => props.textDecoration ?? "none"};
`;